import React from "react";
import { Reveal } from "@/components/Reveal";
import { FAQS, waLink } from "@/data/site";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import useSeo from "@/lib/useSeo";

export default function FAQs() {
  useSeo({ title: "FAQs", description: "Frequently asked questions about VacanzaGo tours — booking, payment, cancellation and events." });
  return (
    <div className="pt-28 pb-24 bg-[#FFF7EC] min-h-screen">
      <div className="max-w-3xl mx-auto px-4 sm:px-8 lg:px-12">
        <Reveal className="mb-10">
          <p className="eyebrow">Questions</p>
          <h1 className="font-display text-5xl sm:text-6xl font-medium tracking-tight mt-3 text-[#2A1808]">Frequently asked</h1>
        </Reveal>
        <Reveal>
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={f.q} value={`item-${i}`} className="rounded-md border border-[#553204]/10 bg-[#FFFBF5] px-5">
                <AccordionTrigger className="text-left font-display text-xl text-[#2A1808] hover:no-underline" data-testid={`faq-q-${i}`}>{f.q}</AccordionTrigger>
                <AccordionContent className="text-[#553204] text-sm leading-relaxed pb-4">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
        <div className="mt-10 text-center">
          <p className="text-[#553204]">Still have a question?</p>
          <a href={waLink()} target="_blank" rel="noreferrer" className="inline-block mt-3 rounded-full btn-orange px-7 py-3 text-sm">Chat on WhatsApp</a>
        </div>
      </div>
    </div>
  );
}
